export default "__VITE_ASSET__av_Bo5us__"